export class EventClass {
     _element = document;
     functionMap = [];

     constructor(el?) {
          if (el) this._element = el;
     }

     addEventListener(event, func) {
          let eventId = [event, func];
          this.functionMap.push(eventId);
          document.addEventListener(event.split('.')[0], eventId[1]);
     }

     removeEventListener(event) {
          let results = this.functionMap.filter((data) => {
               return data[0] === event;
          });
          results.forEach((res) => {
               let targetIndex = this.functionMap.indexOf(res);
               if (targetIndex >= 0) {
                    let eventName = res[0].split('.')[0];
                    let registeredHandler = res[1];
                    document.removeEventListener(eventName, registeredHandler);
                    this.functionMap.splice(targetIndex);
               }
          });
     }

     removeAll() {
          this.functionMap.forEach((res) => {
               let eventName = res[0].split('.')[0];
               let eventHandler = res[1];
               this._element.removeEventListener(eventName, eventHandler);
          });
     }
}
